
// export const createStandardItemPreview = <T extends Physical>(type: ComponentType<T>, cols: number, rows: number) =>
//     (operation: TabularImportOperation, page?: number): TabularImportItemPreviewPage => {
//         const { data, hasHeaders, mappings } = operation;
//         page = page ?? 0;

import { ComponentType } from '../../../../concepts/objects';
import { IsolatedObjectManager } from '../../../../concepts/objects/IsolatedObjectManager';
import { Physical } from '../../../canvas/entities/Physical';
import { GridLayout } from '../../../canvas/layout/GridLayout';
import { Pen } from '../../../canvas/layout/Pen';
import { TabularImportStrategy } from '../TabularImportModel';

export const createMappingOnlyTabularImportStrategyFunction = (itemType: ComponentType<Physical>): TabularImportStrategy['apply'] =>
    (data, params) => {

        const items = params.hasHeaders ? data.slice(1) : data;
        const mappings = params.mappings ?? [];

        const iom = new IsolatedObjectManager();
        const figures = items.map(tm => {
            const f = iom.create(itemType);
            for (const [t, s] of mappings) {
                f.set(t.path, t.filter(tm[s.key]));
            }
            return f as Physical;
        });

        GridLayout.compute(Pen.from(figures)).apply();
        return figures.map(x => x.toTuple());
    };
